// src/components/Filters.js
import React from 'react';

const Filters = ({ onFilterSelect, termData }) => {
  const initialLetters = [...new Set(termData.map(term => term.term[0].toUpperCase()))].sort();

  const handleFilterClick = (letter) => {
    onFilterSelect(letter);
  };

  return (
    <div className="filter-container">
      <button onClick={() => handleFilterClick('All')}>All</button>
      {initialLetters.map(letter => (
        <button key={letter} onClick={() => handleFilterClick(letter)}>
          {letter}
        </button>
      ))}
    </div>
  );
};

export default Filters;
